export interface HistoryEntry {
  id: string
  title: string
  tokens: number
}

export interface HistoryPopoverProps {
  items: HistoryEntry[]
  onSelect: (id: string) => void
}

export function HistoryPopover({ items, onSelect }: HistoryPopoverProps) {
  return (
    <div className="absolute left-4 right-4 top-2 z-20 overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-lg">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          className="flex w-full items-center justify-between gap-3 border-b border-neutral-100 px-4 py-3 text-left last:border-0 hover:bg-neutral-50"
        >
          <span className="truncate text-sm text-neutral-800">{item.title}</span>
          <span className="shrink-0 text-xs text-neutral-400">{item.tokens} T.</span>
        </button>
      ))}
    </div>
  )
}
